import { createAsyncThunk } from '@reduxjs/toolkit';
import { toApiError } from '@/services/api/responseHandler';
import { mediaService } from '@/services/media/mediaService';
import type { DeliveryQuotePayload, DeliveryQuoteResponse, MediaCartSummaryResponse, MediaCheckoutPayload, MediaCheckoutResponse } from '@/types/media';

export const fetchMediaCartThunk = createAsyncThunk<
  MediaCartSummaryResponse,
  void,
  { rejectValue: ReturnType<typeof toApiError> }
>('mediaCart/fetchCart', async (_, { rejectWithValue }) => {
  try {
    return await mediaService.getCart();
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});

export const removeMediaCartItemThunk = createAsyncThunk<
  { cartItemId: string },
  string,
  { rejectValue: ReturnType<typeof toApiError> }
>('mediaCart/removeItem', async (cartItemId, { rejectWithValue }) => {
  try {
    await mediaService.removeCartItem(cartItemId);
    return { cartItemId };
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});

export const updateMediaCartItemQuantityThunk = createAsyncThunk<
  MediaCartSummaryResponse,
  { cartItemId: string; quantity: number },
  { rejectValue: ReturnType<typeof toApiError> }
>('mediaCart/updateQuantity', async ({ cartItemId, quantity }, { rejectWithValue }) => {
  try {
    return await mediaService.updateCartItemQuantity(cartItemId, quantity);
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});

export const fetchDeliveryQuoteThunk = createAsyncThunk<
  DeliveryQuoteResponse,
  DeliveryQuotePayload,
  { rejectValue: ReturnType<typeof toApiError> }
>('mediaCart/deliveryQuote', async (payload, { rejectWithValue }) => {
  try {
    return await mediaService.deliveryQuote(payload);
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});

export const mediaCheckoutThunk = createAsyncThunk<
  MediaCheckoutResponse,
  MediaCheckoutPayload,
  { rejectValue: ReturnType<typeof toApiError> }
>('mediaCart/checkout', async (payload, { rejectWithValue }) => {
  try {
    return await mediaService.checkout(payload);
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});